<div>
    <canvas baseChart
            [type]="'line'"
            [data]="chartData"
            [options]="chartOptions"
            [legend]="chartLegend">
    </canvas>
</div>
